<template>
  <div
    v-if="data"
    :class="$style.root"
  >
    <LayoutPageContentComponent :parentTitle="parentTitle">
      <template #close>
        <i18nLink :to="{ name: 'calendar' }">
          <CoreButtonsCloseComponent />
        </i18nLink>
      </template>

      <template #content>
        <LayoutHeadingComponent
          :title="page?.title"
          :subtitles="page?.secondaryTitles"
          :categories="page?.calendarCategories?.data"
        >
          <CoreDateTimeRangeComponent
            v-if="page?.dateTimeStart"
            :dateStart="page?.dateTimeStart"
            :dateEnd="page?.dateTimeEnd"
          />
        </LayoutHeadingComponent>

        <CoreBlocksImagesImageComponent
          v-if="page?.coverImage?.data?.attributes"
          :class="$style.coverImage"
          :image="page?.coverImage?.data"
        />

        <CoreBlocksComponent
          v-if="page?.blocks"
          :blocks="page?.blocks"
        />

        <SharedEmbeddedMapComponent
          v-if="page?.mapRepresentation?.mapLocation"
          :centerLatLong="page?.mapRepresentation?.mapLocation?.data?.attributes"
          :slug="page?.slug"
          :label="page?.mapRepresentation?.mapLocation?.data?.attributes?.title"
        />

        <SharedCommunityRelatedComponent
          v-if="page?.communityEntries?.data?.length"
          :items="page?.communityEntries?.data"
        />

        <SharedProjectsRelatedComponent
          v-if="page?.projectEntries?.data?.length"
          :items="page?.projectEntries?.data"
        />

        <SharedBulletinBoardRelatedComponent
          v-if="page?.bulletinBoardEntries?.data?.length"
          :items="page?.bulletinBoardEntries?.data"
        />
      </template>
    </LayoutPageContentComponent>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
  parentTitle: {
    type: String,
    required: false
  },
})

const page = baseStrapiGetAttributes(props.data)

useHead({
  htmlAttrs: {
    style: '--color--background: var(--color--calendar);'
  }
})
</script>

<style module>
.root {
  padding: var(--padding--container);
  padding-top: 0;
}

.coverImage {
  --base--image--max-aspect-ratio: 6 / 9;
  margin-bottom: calc(var(--unit--vertical) * 2);
}
</style>
